const products = {
  computed: {
    getProductPrice() {
      const store = this.storeData || {};
      const product = this.product || {};
      return this.getPrices({ product, store });
    },
  },
  methods: {
    getFromPercent(total, percent) {
      return parseFloat((percent / 100) * total).toFixed(2);
    },
    getPrices({ product, store }) {
      const payload = { live: 0, original: false };
      if (!isNaN(parseFloat(product.price)) && isFinite(product.price)) {
        payload.live = product.price;
        const storeWide = store.discounts && store.discounts.storeWide;
        if (storeWide) {
          const percentage = parseInt(store.discounts.storeWide, 10);
          if (percentage > 0) {
            payload.original = product.price;
            const discount = this.getFromPercent(product.price, percentage);
            payload.live -= parseFloat(discount);
          }
        }
      }
      return payload;
    },
  },
};

export { products };



// WEBPACK FOOTER //
// ./src/mixins/products.js